import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-tables.css';
var getClassNameList = classNames.bind(styles);
var UitkTableBody = function (props) {
  var _a;
  var children = props.children,
    className = props.className,
    frozenRow = props.frozenRow;
  var baseClassName = 'uitk-table-body';
  return React.createElement("tbody", {
    className: getClassNameList(className, (_a = {}, _a["".concat(baseClassName, "-frozen")] = frozenRow === 'bodyRow', _a))
  }, children);
};
UitkTableBody.displayName = 'UitkTableBody';
export { UitkTableBody };